import { bootstrapApplication } from '@angular/platform-browser';
import { provideHttpClient } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { routes } from './site.routes';
import { Site } from './site';

bootstrapApplication(Site, {
    providers: [
        provideRouter(routes),
        provideHttpClient()
    ]
}).catch((err) => console.error(err));
